<template>
	<div>
		<CModal title="Ajouter une correction" size="lg" :show.sync="showModal">
			<form ref="mainForm" action="/api/pos_credit_notes" method="post" axiosMethod="post">
				<input type="hidden" name="invoice" :value="`/api/pos_invoices/${posInvoiceId}`" />

				<CRow>
					<CCol col="12">
						<CInput name="description" label="Description" />
					</CCol>
				</CRow>
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	export default {
		name: 'credit-notes-add-modal',
		data() {
			return {
				showModal: false,
				posInvoiceId: {},
			};
		},

		methods: {
			onSubmit(form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
